import React from "react";
import Buttons from "./Buttons";
import TableData from "./TableData";

const AssetsTable = () => {
  return (
    <div className="w-full">
      <Buttons />
      <TableData />
    </div>
  );
};

export default AssetsTable;
